// Automatically generated by 'set-build-info.js'
export const version = '0.0.1';
export const buildDate = '2026-05-11T13:38:18.633Z';
